import * as React from 'react';
import ClassicEnrollmentFilterRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicEnrollmentFilterRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ClassicReenrollmentIntegrationsEventFilterRenderer = ({
  portalId,
  objectTypeId,
  condensed,
  reEnrollmentTriggerSet
}) => {
  if (!reEnrollmentTriggerSet[0].filters) {
    // filter is invalid
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: reEnrollmentTriggerSet[0].filters.map((filter, i) => /*#__PURE__*/_jsx(ClassicEnrollmentFilterRenderer, {
      objectTypeId: objectTypeId,
      portalId: portalId,
      filters: [{
        ands: [filter]
      }],
      condensed: condensed
    }, i))
  });
};
export default ClassicReenrollmentIntegrationsEventFilterRenderer;